import { useSelector } from 'react-redux';

import Button from 'atoms/button';

export default function Header({ setMode, isEditing, onSave }) {
  const {
    servicedAnimals,
    firstName,
    lastName,
    phone,
    countryCodeId,
    email,
    services,
    role,
  } = useSelector((state) => state.groomerForm);
  const title = isEditing ? 'Edit' : 'Groomer details';
  const canContinue =
    firstName &&
    lastName &&
    phone &&
    countryCodeId &&
    email &&
    services.filter((el) => el.name).length > 0 &&
    servicedAnimals.length > 0;

  return (
    <div className="flex-row justify-between mb-25">
      <h2 className="f26">{title}</h2>
      {isEditing ? (
        <div className="flex-row">
          <Button
            text="Cancel"
            size="extra-small"
            shape="round"
            variant="reverse"
            className="mr-12"
            onClick={() => setMode('preview')}
          />
          <Button
            text="Save"
            size="extra-small"
            shape="round"
            variant={canContinue ? 'default' : 'disabled'}
            onClick={onSave}
          />
        </div>
      ) : (
        <Button
          text="Edit"
          size="extra-small"
          shape="round"
          variant="reverse"
          onClick={() => setMode('edit')}
        />
      )}
    </div>
  );
}
